import { Toast } from "vant-ui";
import axios from "#/net/axios.js";
import Vue from "vue";
import { setCart, getCart, clearCart, } from '@/storage/cart.js'

/**
 * vuex
 */
const state = {
    cartInfoAll: {
        
    },
}

const getters = {
    getCartInfo: state => shopId => {
        if (!state.cartInfoAll[shopId])
        {
            state.cartInfoAll[shopId] = {
                shoppingCarLoseEffectList: [],
                shoppingCars: getCart(shopId),
            }
        }

        //
        return state.cartInfoAll[shopId];
    },
}

const mutations = {
    setCartInfo(state, {
        shopId,
        data
    }) {

        //
        if (!state.cartInfoAll[shopId])
        {
            //
            state.cartInfoAll[shopId] = data;
        }
        else
        {
            // accept server cart data
            state.cartInfoAll[shopId].shoppingCarLoseEffectList = data.shoppingCarLoseEffectList;
            state.cartInfoAll[shopId].shoppingCars = data.shoppingCars;
        }
        
        //
        Vue.set(state.cartInfoAll, `time_${Date.now()}`, "CurrentDate");

        //
        setCart(shopId, JSON.stringify(state.cartInfoAll[shopId].shoppingCars))
    },

    clearCartInfo(state, shopId) {
        //
        if (!state.cartInfoAll[shopId])
        {
            state.cartInfoAll[shopId] = {
                shoppingCarLoseEffectList: [],
                shoppingCars: [],
            };
        }

        //
        state.cartInfoAll[shopId].shoppingCarLoseEffectList = []
        state.cartInfoAll[shopId].shoppingCars = []

        //
        Vue.set(state.cartInfoAll, `time_${Date.now()}`, "CurrentDate");

        //
        clearCart(shopId);
    },

    refreshCart(state, shopId) {
        //
        Vue.set(state.cartInfoAll, `time_${Date.now()}`, "CurrentDate");

        //
        setCart(shopId, JSON.stringify(state.cartInfoAll[shopId].shoppingCars))
    }
}

const actions = {
    getCart({ commit, getters }, {
        shopId,
        forceUpdate = false,
        cb,
    }) {
        //
        if (!forceUpdate && getters.getCartInfo(shopId).shoppingCars !== null && getters.getCartInfo(shopId).shoppingCars.length > 0) {
            if (cb) {
                cb();
            }

            //
            return;
        }

        //
        axios.shop
            .get('/shoppingCarController/getUserCartByShopId.do', {
                shopId,
            })
            .then(({ statusCode, msg, data }) => {
                if(statusCode == "500")
                {
                    Toast("请先进行登录");
                }
                else if (statusCode !== '200' && statusCode !== '401' && statusCode !== '900') {
                    //
                    if (cb) {
                        cb(msg);
                    }


                    //
                    return Toast(`获取购物车信息失败, ${msg}`)
                }
                else if (statusCode == '200') {
                    //
                    if (data) {
                        commit('setCartInfo', {
                            shopId,
                            data
                        });
                    }
                    else {
                        commit('clearCartInfo', shopId);
                    }

                    //
                    if (cb) {
                        cb();
                    }
                }
            })
            .catch(e => {
                if (cb) {
                    cb(`获取购物车信息失败, ${e.toString()}`)
                }

                //
                Toast(`获取购物车信息失败, ${e.toString()}`)
            });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
